import { render, staticRenderFns } from "./AmazingTeam.vue?vue&type=template&id=2293160b&"
import script from "./AmazingTeam.vue?vue&type=script&lang=js&"
export * from "./AmazingTeam.vue?vue&type=script&lang=js&"
import style0 from "./AmazingTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports